import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Range } from 'slate';
import getToolbarButtons from './utils/getToolbarButtons';
import { BASIC_SELECTION, BASIC_INSERTION, EXPANDED_SELECTION, EXPANDED_INSERTION } from '../utils/makeToolbarButton';
import asColumns from './utils/asColumns';
var COMMAND_BEFORE = /(?:^|\s)(\/)([\w]{0,10})$/;
var COMMAND_AFTER = /^([\w]{0,10})/;
export function isCommand(editor) {
  if (editor.value.selection.isUnset) return false;
  var _editor$value = editor.value,
      selection = _editor$value.selection,
      startText = _editor$value.startText;
  var textBefore = startText.text.slice(0, selection.start.offset);
  var textAfter = startText.text.slice(selection.start.offset);
  return COMMAND_BEFORE.test(textBefore) && COMMAND_AFTER.test(textAfter);
}
export var DEFAULT_STATE = {
  buttons: [],
  hoverButton: null,
  index: 0,
  columnCount: 3,
  isSelection: false,
  isInsertion: false,
  isPrompt: false,
  isOpen: false,
  isExpanded: false,
  isDismissed: false,
  isMinimal: false,
  position: 'top',
  selection: null,
  command: null,
  prompt: null
};

function getButtonList(editor, _ref) {
  var command = _ref.command,
      isSelection = _ref.isSelection,
      isInsertion = _ref.isInsertion,
      isExpanded = _ref.isExpanded;

  if (command !== null) {
    return getToolbarButtons(editor).filter(function (button) {
      return button.visibility & (BASIC_INSERTION | EXPANDED_INSERTION);
    }).filter(function (button) {
      return button.searchTerms.join(' ').indexOf(command.toLowerCase()) >= 0;
    });
  }

  return getToolbarButtons(editor).filter(function (button) {
    return isExpanded ? isSelection && button.visibility & EXPANDED_SELECTION || isInsertion && button.visibility & EXPANDED_INSERTION : isSelection && button.visibility & BASIC_SELECTION || isInsertion && button.visibility & BASIC_INSERTION;
  });
}

export function open() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var editor = arguments.length > 1 ? arguments[1] : undefined;
  var _editor$value2 = editor.value,
      selection = _editor$value2.selection,
      startText = _editor$value2.startText;
  var isSelection = editor.isToolbarSelection();
  var isInsertion = editor.isToolbarInsertion();
  var command = null;

  if (isInsertion && startText.text !== '') {
    var textBefore = startText.text.slice(0, selection.start.offset);
    var textAfter = startText.text.slice(selection.start.offset);
    command = COMMAND_BEFORE.exec(textBefore)[2] + COMMAND_AFTER.exec(textAfter)[1];
  }

  var isExpanded = isInsertion === state.isInsertion && isSelection === state.isSelection && command === state.command ? state.isExpanded : DEFAULT_STATE.isExpanded;
  var isDismissed = isInsertion === state.isInsertion && isSelection === state.isSelection && command === state.command ? state.isDismissed : DEFAULT_STATE.isDismissed;
  var isMinimal = isInsertion && !isExpanded && command === null;
  var buttons = getButtonList(editor, _objectSpread({}, state, {
    command: command,
    isSelection: isSelection,
    isInsertion: isInsertion,
    isExpanded: isExpanded,
    isDismissed: isDismissed,
    isMinimal: isMinimal
  }));
  var index = Math.min(state.index, buttons.length - 1);
  return _objectSpread({}, state, {
    index: index,
    isOpen: buttons.length > 0,
    isSelection: isSelection,
    isInsertion: isInsertion,
    position: isInsertion ? 'bottom' : 'top',
    command: command,
    buttons: buttons,
    hoverButton: buttons[index],
    isExpanded: isExpanded,
    isDismissed: isDismissed,
    isMinimal: isMinimal
  });
}
export function openPrompt() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var editor = arguments.length > 1 ? arguments[1] : undefined;
  var prompt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : state.prompt;
  return _objectSpread({}, state, {
    isPrompt: true,
    prompt: prompt
  });
}
export function closePrompt() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var editor = arguments.length > 1 ? arguments[1] : undefined;
  editor.focus();
  return _objectSpread({}, state, {
    isPrompt: false,
    prompt: null
  });
}
export function close() {
  return DEFAULT_STATE;
}
export function dismiss() {
  return _objectSpread({}, DEFAULT_STATE, {
    isDismissed: true
  });
}
export function expand() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var editor = arguments.length > 1 ? arguments[1] : undefined;
  var isExpanded = true;
  var isMinimal = false;
  var buttons = getButtonList(editor, _objectSpread({}, state, {
    isExpanded: isExpanded
  }));
  var index = Math.min(state.index, buttons.length - 1);
  return _objectSpread({}, state, {
    index: index,
    isExpanded: isExpanded,
    isMinimal: isMinimal,
    buttons: buttons,
    hoverButton: buttons[index]
  });
}
export function collapse() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var editor = arguments.length > 1 ? arguments[1] : undefined;
  var isExpanded = false;
  var isMinimal = state.isInsertion && state.command === null;
  var buttons = getButtonList(editor, _objectSpread({}, state, {
    isExpanded: isExpanded
  }));
  var index = Math.min(state.index, buttons.length - 1);
  return _objectSpread({}, state, {
    index: index,
    isExpanded: isExpanded,
    isMinimal: isMinimal,
    buttons: buttons,
    hoverButton: buttons[index]
  });
}
export function setHoverButton() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var editor = arguments.length > 1 ? arguments[1] : undefined;
  var button = arguments.length > 2 ? arguments[2] : undefined;
  var index = state.buttons.indexOf(button);
  return _objectSpread({}, state, {
    index: index,
    selected: false,
    hoverButton: state.buttons[index]
  });
}
export function moveUp() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var index = Math.max(state.index - 1, 0);
  return _objectSpread({}, state, {
    index: index,
    selected: true,
    hoverButton: state.buttons[index]
  });
}
export function moveDown() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var index = Math.min(state.index + 1, state.buttons.length - 1);
  return _objectSpread({}, state, {
    index: index,
    selected: true,
    hoverButton: state.buttons[index]
  });
}
export function moveLeft() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var buttons = state.buttons,
      columnCount = state.columnCount;
  var columns = asColumns(buttons);
  var currentColumnIndex = Math.floor(state.index / (buttons.length / columnCount));
  var index = currentColumnIndex > 0 ? state.index - columns[currentColumnIndex - 1].length : state.index;
  return _objectSpread({}, state, {
    index: index,
    selected: true,
    hoverButton: state.buttons[index]
  });
}
export function moveRight() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var buttons = state.buttons,
      columnCount = state.columnCount;
  var columns = asColumns(buttons);
  var currentColumnIndex = Math.floor(state.index / (buttons.length / columnCount));
  var currentIndexInColumn = state.index;

  for (var i = 0; i < currentColumnIndex; i++) {
    currentIndexInColumn = currentIndexInColumn - columns[currentColumnIndex].length;
  }

  var index = currentColumnIndex < columns.length - 1 ? state.index + (currentIndexInColumn >= columns[currentColumnIndex + 1].length ? columns[currentColumnIndex + 1].length : columns[currentColumnIndex].length) : state.index;
  return _objectSpread({}, state, {
    index: index,
    selected: true,
    hoverButton: state.buttons[index]
  });
}
export function commit() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var editor = arguments.length > 1 ? arguments[1] : undefined;
  var hoverButton = state.hoverButton;

  if (!hoverButton || hoverButton.canApply && !hoverButton.canApply(editor)) {
    return;
  }

  var apply = hoverButton.onApply || hoverButton.onClick;

  if (state.command === null) {
    return apply(editor.snapshotSelection());
  }

  var _editor$value3 = editor.value,
      startText = _editor$value3.startText,
      selection = _editor$value3.selection;
  var textBefore = startText.text.slice(0, selection.start.offset);
  var textAfter = startText.text.slice(selection.start.offset);
  var matchBefore = COMMAND_BEFORE.exec(textBefore);
  var matchAfter = COMMAND_AFTER.exec(textAfter);
  var startOffset = matchBefore.index + matchBefore[0].indexOf(matchBefore[1]);
  var endOffset = matchAfter.index + selection.start.offset + matchAfter[1].length;
  var range = Range.create({
    anchor: selection.start.setOffset(startOffset),
    focus: selection.start.setOffset(endOffset)
  }).normalize(editor.value.document);
  apply(editor.snapshotSelection().deleteAtRange(range));
}